import React from 'react';

interface UserAvatarProps {
  avatarUrl: string | null;
  firstName: string;
  lastName: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'w-8 h-8 text-xs',
  md: 'w-16 h-16 text-lg',
  lg: 'w-32 h-32 text-3xl',
};

function getInitials(firstName: string, lastName: string): string {
  const first = firstName.trim().charAt(0).toUpperCase();
  const last = lastName.trim().charAt(0).toUpperCase();
  return last ? `${first}${last}` : first;
}

const UserAvatar: React.FC<UserAvatarProps> = ({
  avatarUrl,
  firstName,
  lastName,
  size = 'md',
  className = '',
}) => {
  const classes = sizeClasses[size];

  if (avatarUrl) {
    return (
      <img
        src={avatarUrl}
        alt={`Avatar de ${firstName}`}
        className={`${classes} rounded-full object-cover ${className}`}
      />
    );
  }

  return (
    <div
      className={`${classes} rounded-full bg-primary-600 text-white flex items-center justify-center font-semibold select-none ${className}`}
      aria-label={`Avatar de ${firstName}`}
    >
      {getInitials(firstName, lastName)}
    </div>
  );
};

export default UserAvatar;
